/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetContainersQuery } from '../../models/get-containers-query';
import { GetContainersQueryResult } from '../../models/get-containers-query-result';

export interface ApiContainersGetContainersPost$Params {
      body?: GetContainersQuery
}

export function apiContainersGetContainersPost(http: HttpClient, rootUrl: string, params?: ApiContainersGetContainersPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetContainersQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiContainersGetContainersPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetContainersQueryResult>;
    })
  );
}

apiContainersGetContainersPost.PATH = '/api/Containers/GetContainers';
